
import styled from "styled-components"

const FooterText = styled.p`
color: #fff;
padding: 10px 0 10px 0;
@media ${props => props.theme.media.tablet}{
    font-size: 10px;
    display:flex;
    flex-direction: column;
    
}
@media ${props => props.theme.media.phone}{
   font-size: 10px;
   display:flex;
    flex-direction: column;
}

`
const FooterStyled = styled.footer`
margin: 0 auto;
text-align: center;
position: absolute;
bottom:0;
left:0;
right:0;
`
const Footer = () =>{



    return(
        <FooterStyled>
            <FooterText>National Bank of Ukraine Free API  © Copiright 2023  <a style={{color:'#fff'}} target='_blank' href="https://www.linkedin.com/in/vladyslav-zinchenko-67414a205/">Vlad Zinchenko</a></FooterText>
        </FooterStyled>
    )
}

export default Footer;